import { useSpentStatistics } from '@app/api/dashboard/useDashboard';
import SpentChart from '@widgets/dashboard/SpentChart';

export default function DashboardSpentChart() {
  const { statistics } = useSpentStatistics();

  return <SpentChart statistics={statistics} />;
}
